import React, { useState, useEffect } from "react";

const Slideshow = ({ slides }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [typingSpeed, setTypingSpeed] = useState(100); // Aumentado para desacelerar a digitação (antes 150 era a velocidade, aqui definimos a base)

  const currentSlide = slides && slides.length > 0 ? slides[currentIndex] : null;

  useEffect(() => {
    if (!slides || slides.length === 0) return;

    const handleTyping = () => {
      const i = loopNum % slides.length;
      const fullTxt = slides[i]?.titulo || slides[i]?.title || "Slide";

      if (isDeleting) {
        setDisplayText(fullTxt.substring(0, displayText.length - 1));
        setTypingSpeed(40); // Velocidade ao apagar o texto
      } else {
        setDisplayText(fullTxt.substring(0, displayText.length + 1));
        setTypingSpeed(120); // Velocidade ao escrever (maior = mais lento e legível)
      }

      if (!isDeleting && displayText === fullTxt) {
        // Pausa de 4 segundos (4000ms) com o texto completo na tela antes de começar a apagar/trocar
        setTimeout(() => setIsDeleting(true), 4000); 
      } else if (isDeleting && displayText === "") {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
        setCurrentIndex((prev) => (prev + 1) % slides.length);
      }
    };

    const timer = setTimeout(handleTyping, typingSpeed);
    return () => clearTimeout(timer);
  }, [displayText, isDeleting, loopNum, slides, typingSpeed]);

  if (!slides || slides.length === 0) {
    return (
      <div className="w-100 h-100 d-flex align-items-center justify-content-center text-center text-white" style={{ minHeight: '85vh', backgroundColor: '#111' }}>
        <div className="z-2 px-3">
          <h1 className="display-4 fw-bold">Slide</h1>
          <p className="lead text-muted">Nenhum slide disponível no momento.</p>
        </div>
      </div>
    );
  }

  const bgImage = currentSlide.foto || currentSlide.imagem || currentSlide.image || "";
  const descriptionText = currentSlide.descricao || currentSlide.description || "";

  return (
    <div 
      className="w-100 h-100 d-flex align-items-center justify-content-center text-center text-white position-relative overflow-hidden" 
      style={{ 
        minHeight: '85vh',
        width: '100%',
        backgroundImage: bgImage ? `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.6)), url(${bgImage})` : 'none',
        backgroundColor: '#111',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        // Transição suave da imagem de fundo com duração de 1.5 segundos
        transition: 'background-image 1.5s ease-in-out'
      }}
    >
      <div className="z-2 px-3 container" style={{ maxWidth: '1000px' }}>
        <h1 className="display-3 fw-bold mb-3 text-white" style={{ minHeight: '1.2em', textShadow: '0 2px 4px rgba(0,0,0,0.8)' }}>
          {displayText}
          <span className="cursor" style={{ borderRight: '4px solid #ffc107', animation: 'blink 0.7s infinite' }}>|</span>
        </h1>
        {descriptionText && (
          <p className="lead text-light mb-4" style={{ textShadow: '0 1px 3px rgba(0,0,0,0.8)' }}>{descriptionText}</p>
        )}
      </div>

      <style>{`
        @keyframes blink {
          0% { opacity: 1; }
          50% { opacity: 0; }
          100% { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default Slideshow;